import type { SVGProps } from 'react';

const SvgRecentCollections = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M12 11.002c.55 0 1-.45 1-1s-.45-1-1-1H5v-3c0-.55.45-1 1-1h3c.7 0 1.28.39 1.95.83.82.55 1.75 1.17 3.05 1.17h4c.55 0 1 .45 1 1s.45 1 1 1 1-.45 1-1c0-1.65-1.35-3-3-3h-4c-.7 0-1.28-.39-1.95-.83-.82-.55-1.75-1.17-3.05-1.17H6c-1.65 0-3 1.35-3 3v10c0 1.65 1.35 3 3 3h3c.55 0 1-.45 1-1s-.45-1-1-1H6c-.55 0-1-.45-1-1v-5z"
    />
    <path
      fill="currentcolor"
      d="M16 13.002c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1h1.5c.55 0 1-.45 1-1s-.45-1-1-1H17v-1c0-.55-.45-1-1-1"
    />
    <path
      fill="currentcolor"
      d="M16 10.002c-.55 0-1 .45-1 1s.45 1 1 1c2.21 0 4 1.79 4 4a3.999 3.999 0 0 1-6.4 3.2c-.44-.33-1.07-.24-1.4.2s-.24 1.07.2 1.4c1.04.79 2.29 1.2 3.6 1.2 3.31 0 6-2.69 6-6s-2.69-6-6-6"
    />
  </svg>
);
export default SvgRecentCollections;
